import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Card, Button, Form, Message, Input, Label } from 'semantic-ui-react'
import CircularProgress from '@material-ui/core/CircularProgress'
import { firebaseApp } from 'src/config/firebase'
import userModel from 'src/Models/UserModel'

export default
@observer
class AddDeviceComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      deviceId: '',
      isLoading: false,
      error: null,
      success: null,
    }
  }

  handleDeviceIdChange = (e, { value }) => {
    this.setState({ deviceId: value, error: null, success: null })
  }

  validateForm = () => {
    const { deviceId } = this.state

    if (!deviceId.trim()) {
      this.setState({ error: 'Tablet ID is required' })
      return false
    }

    if (deviceId.length < 3) {
      this.setState({ error: 'Tablet ID must be at least 3 characters long' })
      return false
    }

    return true
  }

  addDevice = async () => {
    if (!this.validateForm()) {
      return
    }

    try {
      this.setState({ isLoading: true, error: null, success: null })

      const { deviceId } = this.state

      const deviceData = {
        id: deviceId.trim(),
        type: 'ANDROID', // Default device type
        databaseId: ``,
        activationCode: '', // Will be set when license is purchased
      }

      // Add device to Firebase
      const newRef = firebaseApp
        .database()
        .ref('/users/' + userModel.userId + '/devices/')
        .push()

      await newRef.set(deviceData)

      this.setState({
        success: 'Tablet added successfully!',
        isLoading: false,
        deviceId: '',
      })

      // Call success callback to refresh device list
      if (this.props.onDeviceAdded) {
        this.props.onDeviceAdded(deviceData)
      }
    } catch (error) {
      console.error('Error adding device:', error)
      this.setState({
        error: 'Failed to add tablet. Please try again.',
        isLoading: false,
      })
    }
  }

  dismissMessage = () => {
    this.setState({ error: null, success: null })
  }

  render() {
    const { deviceId, isLoading, error, success } = this.state
    const { isRequired = false, title = 'Add New Tablet' } = this.props

    return (
      <Card fluid>
        <Card.Content>
          <Card.Header>
            {title}
            {isRequired && <span style={{ color: 'red' }}> *</span>}
          </Card.Header>
          {isRequired && (
            <Card.Meta style={{ color: 'orange', marginBottom: '10px' }}>
              You must add at least one tablet before purchasing a license
            </Card.Meta>
          )}
          <Card.Description>
            Add a new tablet to your account. You'll need the Tablet ID from
            your tablet.
          </Card.Description>
        </Card.Content>

        <Card.Content extra>
          {error && (
            <Message negative onDismiss={this.dismissMessage}>
              <Message.Header>Error</Message.Header>
              <p>{error}</p>
            </Message>
          )}

          {success && (
            <Message positive onDismiss={this.dismissMessage}>
              <Message.Header>Success</Message.Header>
              <p>{success}</p>
            </Message>
          )}

          <Form>
            <Form.Field required>
              <Label>Tablet ID</Label>
              <Input
                placeholder="Enter your tablet ID (e.g., 12345ABCDEF)"
                value={deviceId}
                onChange={this.handleDeviceIdChange}
                disabled={isLoading}
                error={!deviceId.trim() && error}
              />
            </Form.Field>

            <Button
              primary
              fluid
              onClick={this.addDevice}
              disabled={isLoading || !deviceId.trim()}
            >
              {isLoading ? (
                <>
                  <CircularProgress size={16} style={{ marginRight: '8px' }} />
                  Adding Tablet...
                </>
              ) : (
                'Add Tablet'
              )}
            </Button>
          </Form>
        </Card.Content>
      </Card>
    )
  }
}
